export async function init(): Promise<void> {
    const gLightbox = document.querySelector<HTMLElement>(".projects-gallery");
    if (!gLightbox) return;

    const { default: GLightbox } = await import('glightbox');
    GLightbox({ selector: '.gallery-item' });
}
